import React from "react";
import { Stack, SxProps, Theme } from "@mui/material";
import logo from "../assets/images/logo.png";

export default function WyndLogo({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Stack sx={sx}>
      <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={logo}
        alt="Wynd Logo"
      />
    </Stack>
  );
}
